module.exports = __webpack_public_path__ + "img/齐鲁银行.226a53e0.png";